import { useState, useEffect, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import styles from "../ResetPin/resetPin.module.css"; // Import CSS module
import { acceptInvite, addUserToGroup, createAppUser, createNewPin, provisionUser, removeUser } from "../Api Methods/Api";
import { useDispatch, useSelector } from "react-redux";
import knowioLogo from '../assets/knowio-logo.png'
import resureLogo from '../assets/resure-logo.png'
import { Button } from "primereact/button";
import API from '../Api Methods/Api'
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import { isValidPhoneNumber } from 'react-phone-number-input';


const CreateUserPortal = ({setSuccessVisible, setFailVisible, setCreateAccountVisible, groupID}) => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const company = useSelector(state => state.auth.companyName);
    let appName = "portal";
    if (appName == "RE:SURE") {
        appName = "RESURE"
    }

    let logoMapping = [
        knowioLogo,
        resureLogo
    ]

    let icon = appName == "RESURE" ? logoMapping[1] : logoMapping[0]

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [confirmEmail, setConfirmEmail] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("+44");

    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);

    const dispatch = useDispatch();
    const userID = useSelector(state => state.auth.userID);
    
    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token); 

    const apiData = {
        token,
        client
    }

    const validatePhoneNumber = (phoneNumber) => {
        return false
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (name == "") {
            setMessage("Please enter a name")
            return;
        }

        if (email == "") {
            setMessage("Please enter an email address")
            return;
        }

        if (email !== confirmEmail) {
            setMessage("Email addresses do not match")
            return;
        }

        if (!isValidPhoneNumber(phoneNumber)){
            setMessage("Please enter a valid phone number");
            return;
        }

        setLoading(true);

        try {
            const accountBody = {
                email: email,
                name: name,
                appName: company,
                verified: "yes",
                phoneNumber: phoneNumber,
                createdBy: userID
            }

            let portalBody = {
                groupID: groupID,
                email: email,
                role: "TechSupport",
                owner: 0,
            }

            const response = await provisionUser(apiData, accountBody, dispatch)
            if (response.success) {
                //do portal invite
                const portalResponse = await addUserToGroup(apiData, portalBody, dispatch)
                if (portalResponse.success){
                    setCreateAccountVisible(false)
                    setSuccessVisible(true)
                }
            } else {
                //show error 
                setFailVisible(true)
            }
        } catch (error) {
            setMessage("Network error, please check your connection & try again. Error: " + error)
        }

        setLoading(false);
    };

    return (
        <div className={`${styles[appName]} ${styles.container}`}>

            <div className={`${styles.card} ${styles[appName]}`}>
                <h4 className={`${styles.titleText} ${styles[appName]}`}>Create account and invite them to the Portal.</h4>
                {message && <p className={styles.errorMessage}>{message}</p>}
                < br/>
                <div className={styles.inputGroup}>
                    <label className={`${styles.inputLabel} ${styles[appName]}`}>Full name</label>
                    <input
                        type="text"
                        className={`${styles.inputField} ${styles["GENERIC"]}`}
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder="First and last name"
                        required
                    />
                </div>

                <div className={styles.inputGroup}>
                    <label className={`${styles.inputLabel} ${styles[appName]}`}>Email address</label>
                    <div>
                        <input
                            type="text"
                            className={`${styles.inputField} ${styles["GENERIC"]}`}
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="name@example.com"
                            required
                        />
                        <input
                            type="text"
                            className={`${styles.inputField} ${styles["GENERIC"]}`}
                            value={confirmEmail}
                            onChange={(e) => setConfirmEmail(e.target.value)}
                            placeholder="Confirm email address"
                            required
                        />
                    </div>
                </div>

                <div className={styles.inputGroup}>
                    <p className={`${styles.inputLabel} ${styles[appName]}`}>Phone number</p>
                    <div className={styles.phoneInput}>
                        <PhoneInput
                            international
                            defaultCountry="GB"
                            value={phoneNumber}
                            onChange={setPhoneNumber}
                        />
                    </div>
                </div>

                <br></br>

                <Button 
                    style={{ width: '100%', backgroundColor: 'var(--Primary-Color)' }} 
                    label={loading ? "Creating account..." : "Create account & invite to Portal"}
                    severity="info" 
                    type="submit" 
                    disabled={loading} 
                    onClick={handleSubmit} 
                />
            </div>
        </div>
    );
};

export default CreateUserPortal;
